import { useMutation } from '@tanstack/react-query';

import { api, MARKETPLACE } from './client';
import type {
  JoinWaitlistRequest,
  JoinWaitlistResponse,
  NewSalonAlertRequest,
  NewSalonAlertResponse,
} from './contracts';

/** `POST /salon/{s}/waitlist` (§9) — "Notify me" when a slot opens. */
export function useJoinWaitlist(subdomain: string) {
  return useMutation<JoinWaitlistResponse, Error, JoinWaitlistRequest>({
    mutationFn: (req) =>
      api<JoinWaitlistResponse>(`${MARKETPLACE}/salon/${subdomain}/waitlist`, {
        method: 'POST',
        body: JSON.stringify(req),
      }),
  });
}

/**
 * `POST /alerts/new-salons` (§9) — "Not finding what you need?" on search.
 * An identical subscription answers 201 with the existing id: success too.
 */
export function useNewSalonAlert() {
  return useMutation<NewSalonAlertResponse | null, Error, NewSalonAlertRequest>({
    mutationFn: async (req) => {
      const out = await api<NewSalonAlertResponse | undefined>(`${MARKETPLACE}/alerts/new-salons`, {
        method: 'POST',
        body: JSON.stringify(req),
      });
      return out ?? null;
    },
  });
}
